import LokasiKerja from './LokasiKerja'

export default LokasiKerja